import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import './Section.css';

export default function Section({ title, link, children, contentClassName = "", hasCollapsibleContent = false }) {
  const [isOpen, setIsOpen] = useState(true);

  const hasContent = React.Children.count(children) > 0;
  const showDropdown = hasCollapsibleContent && hasContent;

  const handleToggle = (e) => {
    if (showDropdown) {
      e.preventDefault();
      e.stopPropagation();
      setIsOpen(!isOpen);
    }
  };

  const renderTitle = () => {
    const titleContent = (
      <>
        {title}
        {showDropdown && (
          <span className={`dropdown-arrow ${isOpen ? 'open' : ''}`}> ></span>
        )}
      </>
    );

    if (link) {
      return (
        <div className="section-title-container">
          <NavLink to={link} className="section-title-link">
            {title}
          </NavLink>
          {showDropdown && (
            <span 
              className={`dropdown-arrow ${isOpen ? 'open' : ''}`}
              onClick={handleToggle}
            >
              {' >'}
            </span>
          )}
        </div>
      );
    }

    return (
      <div className="section-title" onClick={handleToggle}>
        {titleContent}
      </div>
    );
  };

  return (
    <div className="section-wrapper">
      {renderTitle()}
      {(!showDropdown || isOpen) && hasContent && (
        <div className={`section-content ${contentClassName}`}>
          {children}
        </div>
      )}
      <div className="section-divider">- - - - - - - - - - - - - - -</div>
    </div>
  );
}

